import { AccountMenu } from "./account-menu";
import { NotificationBell } from "./notifications/notification-bell";
import type { PageTarget } from "./page-back-button";

export function HeaderActions({ from }: { from: PageTarget }) {
  return (
    <div className="flex items-center gap-1">
      <NotificationBell from={from} />
      <AccountMenu from={from} />
    </div>
  );
}
